export const MIN_VISIBLE_ITEMS_COUNT = 3;
